import React from 'react';

import Money from "../Money"
import * as UI from "./ui";

export const calculatePromoTicketCount = (donationLevel, promoCode) => {
  const { rewardTickets } = donationLevel;
  const bonusPercent = (promoCode && promoCode.bonusPercent) || 0;
  return Math.ceil((rewardTickets * bonusPercent) / 100);
}

const DonationLevel = ({ donationLevel, promoTickets, onClick, selected, emphasis, guarded, disabled }) => {
  const inactive = guarded || disabled;
  const { rewardTickets, price } = donationLevel;

  const ticketString = rewardTickets === 1 ? '1 Entry' : `${rewardTickets} Entries`;

  const handleClick = onClick && (() => {
    if(!inactive) {
      onClick(donationLevel);
    }
  })

  const promoTicketString = promoTickets && promoTickets === 1 ? '+1 Promo' : `+${promoTickets} Promo`;

  return (
    <UI.Layout onClick={handleClick} selected={selected} guarded={inactive} level={donationLevel.level}>
      <UI.Price $emphasis={emphasis}>
        <Money cents={price} />
      </UI.Price>
      <UI.Reward>{ticketString}</UI.Reward>
      <UI.Promo applied={promoTickets}>{promoTicketString}</UI.Promo>
    </UI.Layout>
  );
}

export default DonationLevel;
